module.exports = __webpack_public_path__ + "r-v3/img/crown_black.9f5b9988.svg";